import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

const slug = (s) => s.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");

export const InventoryConfigTab = () => {
  const { meta, loadMeta } = useAuth();
  const [classes, setClasses] = useState([]);
  const [units, setUnits] = useState("");
  useEffect(() => { setClasses(meta?.item_classes || []); setUnits((meta?.units || []).join("\n")); }, [meta]);
  const upd = (i, k, v) => setClasses((cs) => cs.map((c, idx) => (idx === i ? { ...c, [k]: v } : c)));
  const save = async () => {
    try {
      await api.put("/settings/inventory", { item_classes: classes.map((c) => ({ ...c, code: c.code || slug(c.name) })), units: units.split("\n") });
      toast.success("Configuración guardada"); loadMeta();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="grid gap-6 md:grid-cols-2" data-testid="inventory-config-tab">
      <div className="space-y-2">
        <h3 className="font-display text-sm uppercase tracking-wider">Clasificaciones</h3>
        <p className="text-xs text-muted-foreground">"Se consume" desactivado = herramienta: se utiliza y regresa, nunca se descuenta como consumo.</p>
        {classes.map((c, i) => (
          <div key={c.code || i} className="flex items-center gap-2" data-testid={`class-row-${i}`}>
            <Input value={c.name} onChange={(e) => upd(i, "name", e.target.value)} className="h-9" data-testid={`class-name-${i}`} />
            <span className="whitespace-nowrap text-xs text-muted-foreground">Se consume</span>
            <Switch checked={c.consumable} onCheckedChange={(v) => upd(i, "consumable", v)} data-testid={`class-consumable-${i}`} />
            {!c.code && <Button size="icon" variant="ghost" onClick={() => setClasses((cs) => cs.filter((_, idx) => idx !== i))}><Trash2 className="h-4 w-4" /></Button>}
          </div>))}
        <Button variant="outline" size="sm" onClick={() => setClasses((cs) => [...cs, { code: "", name: "", consumable: true }])} data-testid="class-add-button"><Plus className="mr-1 h-4 w-4" />Agregar clasificación</Button>
      </div>
      <div className="space-y-2">
        <h3 className="font-display text-sm uppercase tracking-wider">Unidades de medida</h3>
        <textarea value={units} onChange={(e) => setUnits(e.target.value)} rows={9} className="w-full rounded-md border border-border bg-transparent p-2 text-sm" data-testid="units-textarea" />
        <p className="text-xs text-muted-foreground">Una unidad por línea.</p>
      </div>
      <Button onClick={save} className="md:col-span-2 md:w-48" data-testid="inv-config-save">Guardar</Button>
    </div>
  );
};
